import { Button, Col, Form, Input, Row, Space, Spin, Switch } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axiosInstance from '../../../../../../../axios_instance';
import {
  IsAdminContext,
  NumberOfAchivementsContext,
  UserAchievementsDataContext,
} from '../../../../../../../context';
import { errorHandling } from '../../../../../../../utils/helper';
import styles from './styles.module.scss';

interface EditAchievementProps {
  achievement_id: number;
  title: string;
  description: string;
  url: string;
  score: string;
  setIsEditable: any;
  show_in_resume: boolean;
}

const EditAchievement: React.FC<EditAchievementProps> = ({
  achievement_id,
  title,
  description,
  url,
  score,
  setIsEditable,
  show_in_resume,
}) => {
  const { userAchievementsData, setUserAchievementsData } = useContext(
    UserAchievementsDataContext
  );
  const [formData, setFormData] = useState<any>({});
  const [AchievementValue, setAchievementValue] =
    useState<number>(achievement_id);
  const [errorMessage, setErrorMessage] = useState<any>({});
  const [allowSubmit, setAllowSubmit] = useState<boolean>(false);
  const isAdmin = useContext(IsAdminContext);
  const { employeeId } = useParams();
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const [message, setMessage] = useState<string>();
  const { numberOfAchievements, setNumberOfAchievements } = useContext(
    NumberOfAchivementsContext
  );
  const [showInResume, setShowInResume] = useState(show_in_resume);

  const handleChangeResume = (value: any) => {
    setShowInResume(value);
  };

  useEffect(() => {
    setFormData({
      title,
      description,
      url,
      score,
    });
  }, []);

  const handleSave = (values: any) => {
    setIsSubmitted(true);

    // Condition to check if any changes were made
    if (achievement_id) {
      values.show_in_resume = showInResume;
      values.achievement_id = achievement_id;
      let url = '';
      if (isAdmin === '1') {
        url = '/api/v1/admin/profile/achievements';
        values.profile_id = employeeId;
      } else {
        url = '/api/v1/profile/achievements';
      }
      axiosInstance
        .post(url, values)
        .then((response) => {
          const userAchievements = response.data.achievements.filter(
            (Achievement: any) => Achievement['status']['id'] === 1
          );
          // const orderedProjects = response.data.projects.map((ProjectId: number) =>
          //   userProjects.find((userProject: any) => userProject.project_id === ProjectId)
          // ).filter((item: any) => item !== undefined);
          setUserAchievementsData(userAchievements);
          setIsEditable(false);
          setNumberOfAchievements(userAchievements.length);
        })
        .catch((error) => {
          console.log(error);
          errorHandling(error, setErrorMessage);
        })
        .finally(() => {
          setIsSubmitted(false);
        });
    } else {
      setIsEditable(false);
    }
  };

  useEffect(() => {
    if (
      userAchievementsData &&
      userAchievementsData.find(
        (data: any) => data.achievement_id === AchievementValue
      ) &&
      achievement_id !== AchievementValue
    ) {
      setMessage('The Project already exists.');
    } else {
      setMessage('');
    }
  }, [AchievementValue]);

  return (
    <div>
      <Form onFinish={handleSave} scrollToFirstError>
        <Row
          gutter={24}
          style={{ paddingBottom: '40px' }}
          className={styles.row}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              position: 'absolute',
              bottom: '8px',
              right: '30px',
            }}
          >
            <Switch
              defaultChecked={show_in_resume}
              onChange={handleChangeResume}
            />
            <span>Show in resume</span>
          </div>
          <Col className="mb-2" span={12}>
            {message && <p style={{ color: 'green' }}>{message}</p>}
            <Form.Item
              initialValue={title}
              name="title"
              className={styles.title}
              labelAlign="left"
              label="Title"
              rules={[
                { required: true, message: 'Please enter Achievement Title' },
              ]}
            >
              <Input placeholder="Enter Achievement Title" />
            </Form.Item>
          </Col>
          <Col className="mb-2" span={12}>
            <Form.Item
              initialValue={description}
              name="description"
              label="Description"
            >
              <Input.TextArea rows={3} placeholder="Enter Description" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item initialValue={url} name="url" label="Url">
              <Input placeholder="Enter Achievement Url" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item initialValue={score} name="score" label="Score">
              <Input placeholder="Enter Score" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          {isSubmitted ? <Spin /> : null}
          <Form.Item style={{ marginLeft: 'auto' }}>
            <Space>
              <Button
                className={styles['save-button']}
                type="primary"
                htmlType="submit"
              >
                Save
              </Button>
              <Button
                className={styles['cancel-button']}
                onClick={() => setIsEditable(false)}
              >
                Cancel
              </Button>
            </Space>
          </Form.Item>
        </Row>
      </Form>
    </div>
  );
};

export default EditAchievement;
